import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_SCHEDULE,
  GET_SCHEDULE_BY_ID,
  CREATE_SCHEDULE,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_REALIZED,
  DELETE_SCHEDULE,
} from './actionType';

// common success
export const ScheduleApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ScheduleApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetSchedule = (id) => ({
  type: GET_SCHEDULE,
  payload: { id },
});

export const GetScheduleById = (id) => ({
  type: GET_SCHEDULE_BY_ID,
  payload: { id },
});

export const CreateSchedule = (data, history) => ({
  type: CREATE_SCHEDULE,
  payload: { data, history },
});

export const UpdateSchedule = (id, data, history) => ({
  type: UPDATE_SCHEDULE,
  payload: { id, data, history },
});

export const UpdateScheduleRealized = (id, data, history) => ({
  type: UPDATE_SCHEDULE_REALIZED,
  payload: { id, data, history },
});

export const DeleteSchedule = (id) => ({
  type: DELETE_SCHEDULE,
  payload: { id },
});
